import { Component, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NavController, MenuController } from '@ionic/angular';
import { ForgottenUser } from './forgottenPassword.interface';
import { Utils } from '../../service/utils';
import { ForgottenPasswordProvider } from './forgottenPassword.service';
import { ImageConstants } from '../../service/image-constants';
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

@Component({
  selector: 'page-forgotten-password',
  templateUrl: 'forgottenPassword.html',
  providers: [ForgottenPasswordProvider],
  styleUrls: ['forgottenPassword.scss']
})
export class ForgottenPasswordPage {
  forgotPassword: FormGroup;
  isApp: boolean;
  isSubmitted: boolean;
  isLoading: boolean;
  errorMessage: string;
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.onResize();
  }
  constructor(
    public navCtrl: NavController,
    public menu: MenuController,
    private formBuilder: FormBuilder,
    public utils: Utils,
    public ForgottenPassword: ForgottenPasswordProvider,
    public dialog: MatDialog,
    public imageConstants: ImageConstants
  ) {
    this.forgotPassword = this.formBuilder.group({
      userName: new FormControl('', [Validators.required, Validators.pattern(EMAIL_REGEX)])
    });

    this.errorMessage = '';
    this.menu.enable(false);
    this.isSubmitted = false;
    this.isLoading = false;
    this.onResize(); // determine if its the app using ionic

    this.forgotPassword.setValue({
      userName: ''
    });
  }

  onResize = () => {
    this.isApp = this.utils.isApp();
  };

  cancel = () => {
    this.navCtrl.navigateForward('/login');
  };

  onSubmit = ({ value, valid }: { value: ForgottenUser; valid: boolean }) => {
    this.errorMessage = '';
    this.isLoading = true;
    this.ForgottenPassword.forgotPassword(value).subscribe(
      response => {
        //response has access token
        this.isSubmitted = true;
        this.isLoading = false;
      },
      error => {
        this.isLoading = false;
        this.errorMessage = error;
      }
    );
  };

  ngOnInit = () => {
    console.log('ionViewDidLoad ShowPage');
  };
}
